import { PassStatus } from './passes';

/** Tabs of «Пропуска» → filter[status][] (spec §6.5). */
export const PASS_TABS = [
  { id: 'active', label: 'Активные', statuses: [PassStatus.Expected, PassStatus.Inside] },
  { id: 'waiting', label: 'Ожидают', statuses: [PassStatus.Pending, PassStatus.WaitingGuest] },
  { id: 'archive', label: 'Архив', statuses: [PassStatus.InviteCanceled, PassStatus.Expired, PassStatus.Closed] },
] as const;

export type PassTabId = (typeof PASS_TABS)[number]['id'];

export interface PassActions {
  /** What the edit form may change; the server silently ignores guest/plate/type of a used pass. */
  edit: 'all' | 'datesAndComment' | 'dates' | null;
  close: 'close' | 'cancelInvite' | 'blockedInside' | null;
  repeat: boolean;
  save: boolean;
}

/** Card actions by state (spec §6.6). `used` = the pass has ever been inside (status 40 in its events). */
export function passActions(status: number, used: boolean): PassActions {
  switch (status) {
    case PassStatus.Expected:
      return { edit: used ? 'datesAndComment' : 'all', close: 'close', repeat: true, save: true };
    case PassStatus.Inside:
      return { edit: 'datesAndComment', close: 'blockedInside', repeat: true, save: true };
    case PassStatus.WaitingGuest:
      return { edit: 'dates', close: 'cancelInvite', repeat: false, save: false };
    case PassStatus.InviteCanceled:
    case PassStatus.Expired:
    case PassStatus.Closed:
      return { edit: null, close: null, repeat: true, save: true };
    default:
      return { edit: null, close: null, repeat: false, save: false };
  }
}
